import React from 'react'

function Terms_and_condition() {
  return (
    <>
      <section className='disclaimer-section' id='terms'>
        <div className="container">
          <h1>TERMS AND CONDITIONS</h1>

          <h2 className='fw-bold mt-5'>Welcome to Anuyog!</h2>

          <p>By engaging with our services, products, or content, you agree to the following terms and conditions. Please read them carefully before participating in any Anuyog activity or making a purchase.
          </p>

          <h1 className='mt-5'>Acceptance of Terms</h1>
          <p><strong>Scope:</strong> These Terms and Conditions govern all Anuyog offerings, including workshops, courses, product purchases, videos, and other activities.
          </p>
          <p><strong>Agreement:</strong> By participating in Anuyog activities or purchasing products, you agree to these terms.</p>
          <p><strong>Updates:</strong> Anuyog may periodically update these terms. It is your responsibility to review them regularly.</p>


          <h1 className='mt-5'>Consultancy</h1>
          <p>Anuyog Consultancy is committed to offering tailored consultancy services for nourishing your body and mind, healing through the five elements, embracing yoga, pranayama, physical exercises, cultivating fresh organic produce, and building eco-friendly homes for a holistic and sustainable lifestyle. By using our services, you agree to adhere to these terms and conditions.</p>

          <h3 className='fw-bold mt-4'>Client Responsibilities</h3>
          <p><strong>Accuracy of Information:</strong> You agree to provide accurate and complete information during consultations to ensure the best advice.
          </p>
          <p><strong>Personal Responsibility:</strong> You acknowledge that following any advice or guidance from Anuyog Consultancy is done at your own discretion, and Anuyog Consultancy is not liable for any outcomes arising from this.
          </p>

          <h3 className='fw-bold mt-4'>Consultation and Payment</h3>
          <p><strong>Appointment Scheduling:</strong> You may need to schedule an appointment for consultations or other services.
          </p>
          <p><strong>Payment Terms:</strong> Payments for services must be made in full, either in advance or as per the agreement, before receiving any services. Prices are subject to change with prior notice.
          </p>

          <h3 className='fw-bold mt-4'>Intellectual Property</h3>
          <p>All materials, content, and resources provided by Anuyog Consultancy (including, but not limited to, written content, videos, images, and training materials) are the intellectual property of Anuyog Consultancy. Unauthorized use or reproduction of these materials is prohibited.</p>

          <h3 className='fw-bold mt-4'>Confidentiality</h3>
          <p>We respect the confidentiality of the information you share with us during consultations. We will not disclose your personal information without your consent unless required by law. We also ensure that any proprietary data shared is kept confidential.
          </p>

          <h3 className='fw-bold mt-4'>Health Disclaimer</h3>
          <p>While Anuyog Consultancy offers guidance on holistic wellness, nutrition, and natural living, we do not diagnose, treat, or provide medical advice. You should consult with appropriate healthcare professionals for medical concerns. Our advice is based on natural living practices, holistic health, and wellness principles.
          </p>

          <h3 className='fw-bold mt-4'>Limitation of Liability</h3>
          <p>Anuyog Consultancy is not liable for any damages, losses, or negative outcomes that may arise from the use of our services. Our recommendations are based on holistic practices and cannot guarantee specific health outcomes. You use our services at your own risk.</p>

          <h3 className='fw-bold mt-4'>Cancellation and Refund Policy</h3>
          <p><strong>Cancellation:</strong> If you wish to cancel an appointment, please do so at least [insert time frame] in advance. Late cancellations may incur a cancellation fee.
          </p>

          <p><strong>Refunds:</strong> Refunds are only available in certain cases as outlined in your specific service agreement.</p>


          <h1 className='mt-5'>Workshops</h1>
          <p>By registering for our online workshop, you acknowledge that you have read and understood these terms and conditions and agree to be bound by them.
          </p>

          <h3 className='fw-bold mt-4'>Registration, Payment and Refunds </h3>
          <p>Registration is confirmed upon full payment.
          </p>
          <p>Payments are non-refundable unless Anuyog cancels the workshop.
          </p>

          <h3 className='fw-bold mt-4'>Cancellations and Rescheduling</h3>
          <p>Anuyog reserves the right to reschedule or cancel workshops due to unforeseen circumstances. In such cases, participants will be informed promptly and offered either a refund or a seat in a future session.
          </p>
          <p>No refunds will be provided for cancellations made within 48 hours of the activity or for no-shows.
          </p>

          <h3 className='fw-bold mt-4'>Content Usage</h3>
          <p>Materials provided during workshops and courses are for personal use only. Redistribution or reproduction without permission is prohibited.
          </p>

          <h3 className='fw-bold mt-4'>Code of Conduct</h3>
          <p>Participants must behave professionally and respectfully. Harassment, discrimination, or inappropriate behavior will not be tolerated and may result in immediate removal without a refund.
          </p>

          <h3 className='fw-bold mt-4'>Technical Issues</h3>
          <p>Anuyog is not liable for technical difficulties during online sessions. However, reasonable efforts will be made to address issues promptly.
          </p>

          <h3 className='fw-bold mt-4'>Liability Disclaimer</h3>
          <p>The workshops are for educational purposes only. Participants are advised to consult professionals before making lifestyle changes based on the content of the workshops</p>
          <p>Anuyog is not responsible for any injury, loss, or damage incurred during or as a result of participating in our workshops.
          </p>

          <h3 className='fw-bold mt-4'>No Promotions or Marketing</h3>
          <p>You expressly agree to not promote and/or advertise your own business and your own WhatsApp groups either during the workshop or on the support group. Any attempt to do so may result in your immediate removal from the workshop without refund</p>

          <h3 className='fw-bold mt-4'>Meeting in Person</h3>
          <p>You here by agree that if you decide to meet any person whom you may have met through the workshop provided by Anuyog, your decision to meet and/or interact with any such person is solely at your own risk and Anuyog is not liable for any consequences arising thereof.
          </p>

          <h3 className='fw-bold mt-4'>Privacy Policy</h3>
          <p>We respect your privacy and will not share your personal information with third parties unless required by law. By registering for the online workshop, you agree to our privacy policy and acknowledge that we may collect, use, and disclose your personal information as necessary to provide the workshop content and for other legitimate business purposes.
          </p>

          <h3 className='fw-bold mt-4'>Recording Prohibited</h3>
          <p>Recording the online workshop is strictly prohibited. You may not make any audio or video recordings of the workshop content without prior written consent from the workshop provider.
          </p>

          <h3 className='fw-bold mt-4'>Indemnification</h3>
          <p>You agree to indemnify and hold harmless the workshop provider, its affiliates, and its respective officers, directors, employees, and agents from any and all claims, damages, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or in connection with your participation in the online workshop or any breach of these terms and conditions.
          </p>


          <h1 className='mt-5'> Product Purchases</h1>

          <h3 className='fw-bold mt-4'>Order and Delivery</h3>
          <p>You can place your order by calling us, messaging us through WhatsApp, or emailing us. Before placing your order, please enter the following details on the website: Name, Place, Contact Information, Address, and accept the terms and conditions.
          </p>

          <p>The charges mentioned on the website do not include the delivery fee.
            After you place your order, we will inform you of the delivery fee before confirming the shipment.
          </p>

          <p>We deliver to all major cities where BluDart or similar logistics companies operate. For locations outside these cities, please reach out to us to check if a local logistics provider is available for delivery.
          </p>
          <p>Orders are processed only after payment is received. </p>
          <p>Once the order is shipped, no cancellations will be accepted.
          </p>
          <p>All payments made are non-refundable
          </p>
          <p>Delivery timelines may vary depending on the location and other external factors.
          </p>
          <p>Customers must provide accurate delivery details; We are not liable for delays or failed deliveries due to incorrect information.
          </p>
          <p>We will not be held liable for delays or failed deliveries. </p>
          <p>Shipping fees, if applicable, will be displayed during the checkout process.
          </p>
          <p>Risk of loss and ownership of products pass to you upon delivery.
          </p>
          <p>In case of damage or loss during transit, claims must be made directly with the courier company as per their policies.
          </p>

          <h3 className='fw-bold mt-4'>Returns and Refunds:</h3>
          <p>Products may only be returned if they arrive damaged or defective. Refunds or exchanges will be issued after an investigation and a proper reason provided the issue is reported within 3 days of product delivery.
          </p>
          <p>Returned products must be unused, in original packaging, and accompanied by proof of purchase.</p>
          <p>Refunds or Replacements are processed within 30 business days after we receive the returned product.
          </p>
          <p>The final decision of whether the product is Refunded or Replaced is with us.
          </p>

          <h3 className='fw-bold mt-4'>Disclaimer of Warranties</h3>
          <p>Variations in appearance, texture, or color are normal and not grounds for a refund.
          </p>
          <p>We do not guarantee specific results from the use of its products.
          </p>
          <p>We do not warrant that the quality of any products, services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected.
          </p>
          <p>You are responsible for ensuring that your account information is accurate, complete, and up to date.
          </p>
          <p>We do not guarantee that the descriptions, images, or other content are error-free or entirely accurate.
          </p>
          <p>All products are subject to availability. We reserve the right to discontinue any product at any time.
          </p>
          <p>We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. </p>
          <p>We reserve the right to limit the quantities of any products or services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time.
          </p>
          <p>The use of products should not replace professional medical advice. Always consult with a healthcare professional before using any product.
          </p>

          <h1 className='mt-5'> Videos and Online Content</h1>

          <h3 className='fw-bold mt-4'>Access and Usage</h3>
          <p>Videos and other online content are for personal use only. Redistribution, reproduction, or commercial use of Anuyog’s content without prior written consent is prohibited.
          </p>

          <h3 className='fw-bold mt-4'>Accuracy and Disclaimer</h3>
          <p>The content provided is based on research and traditional practices. Anuyog does not guarantee its suitability for every individual. Consult a qualified professional if you have specific health concerns.
          </p>

          <h1 className='mt-5'>Courses</h1>
          <p>By enrolling in the course Anuyog offers, you agree to abide by the following terms and conditions. These terms ensure a positive learning experience and outline your rights and responsibilities.
          </p>

          <h3 className='fw-bold mt-4'>Course Registration</h3>
          <p>All participants must complete the registration form with accurate details, including full name, contact information, and previous experience (if applicable).
          </p>
          <p>Registration is only confirmed once the required payment is received.
          </p>
          <p>By submitting your registration form, you confirm your commitment to participating in the course.
          </p>

          <h3 className='fw-bold mt-4'>Course Payment</h3>
          <p>The course fee must be paid in full before the start of the course. Payment details will be provided during registration.
          </p>
          <p>Anuyog reserves the right to cancel or suspend participation if payment is not completed.</p>

          <h3 className='fw-bold mt-4'>Course Material and Access</h3>
          <p>All course materials, including videos, documents, and resources, are the intellectual property of Anuyog.
          </p>
          <p>Participants are granted access to the course materials for personal use only and agree not to distribute, copy, or share the content with others.
          </p>
          <p>Anuyog may update the course materials from time to time to enhance the learning experience.
          </p>

          <h3 className='fw-bold mt-4'>Attendance</h3>
          <p>Regular attendance is encouraged for optimal learning. Absences should be communicated in advance, where possible.</p>
          <p>It is the responsibility of the participant to catch up on missed content.
          </p>

          <h3 className='fw-bold mt-4'>Cancellations and Refunds</h3>
          <p>If you wish to cancel your enrollment before the course begins or during the course, your admission will be automatically transferred to the next available batch. Please note that no refunds will be provided.
          </p>
          <p>In case of unforeseen circumstances (e.g., illness), Anuyog will evaluate the situation on a case-by-case basis and may offer alternatives.
          </p>

          <h3 className='fw-bold mt-4'>Code of Conduct</h3>
          <p>All participants are expected to act respectfully toward the instructors, other students, and the course environment.
          </p>
          <p>Harassment, discrimination, or any inappropriate behavior will not be tolerated and may result in immediate termination from the course without a refund.
          </p>

          <h3 className='fw-bold mt-4'>Health and Safety</h3>
          <p>While the course is designed to promote well-being through natural health practices, participants should consult with a healthcare professional before beginning any new health or wellness practice.
          </p>
          <p>Anuyog or any of its consultants is not responsible for any injuries or health complications resulting from course participation.
          </p>
          <p>Anuyog or any of its consultants will not be held responsible for any incidents, accidents, or unforeseen circumstances that may occur during the 0.6-month internship period.</p>

          <h3 className='fw-bold mt-4'>Modifications to the Course</h3>
          <p>Anuyog reserves the right to modify or cancel the course in case of unavoidable circumstances (e.g., instructor unavailability, force majeure events).</p>
          <p>If the course is canceled by Anuyog, a full refund will be provided.
          </p>

          <h3 className='fw-bold mt-4'>Privacy and Data Protection</h3>
          <p>By enrolling in the course, you agree to the collection and use of your personal data for course-related purposes, as outlined in Anuyog's privacy policy.
          </p>
          <p>Your data will not be shared with third parties without your explicit consent.
          </p>

          <h3 className='fw-bold mt-4'>Limitation of Liability</h3>
          <p>Anuyog is not responsible for any direct or indirect loss or damage to personal property, or for any injury sustained during the course.
          </p>
          <p>You agree to take full responsibility for your own health and well-being during the course.
          </p>

          <h3 className='fw-bold mt-4'>Agreement to Terms</h3>
          <p>By enrolling in any of the courses, you confirm that you have read, understood, and agreed to these terms and conditions.
          </p>

          <h1 className='mt-5'>Intellectual Property</h1>
          <p>All content, including videos, text, images, and designs, is the intellectual property of Anuyog. Unauthorized use, reproduction, or distribution is strictly prohibited.
          </p>

          <h1 className='mt-5'>Limitation of Liability</h1>
          <p>Anuyog or any of its consultants will not be liable for any direct, indirect, incidental, or consequential damages arising from:
          </p>
          <ul className='fw-bold mt-4 list-group-numbered'>
            <li>Participation in our workshops.
            </li>
            <li>Use of our products.
            </li>
            <li>Reliance on content shared through our videos or other media.
            </li>
          </ul>
          <p>Anuyog or any of its consultants are not responsible for any damages resulting from the use of services, products, or content limit potential legal claims.
          </p>
          <p>You hereby accept full responsibility for any consequences that may arise from your use of the Website, and expressly agree and acknowledge than in no event and under no circumstances we shall be held liable to you for any liabilities or damages resulting from or arising out of your use of the Website.
          </p>
          <p>You agree and acknowledge that you shall not use the Website for any fraudulent, malicious, illegal, or unauthorized purpose/activities. You agree to comply with all applicable laws pertaining to your use of the Website. You further agree and acknowledge that you shall use the Service provided on the Website only for your personal use and not for business purposes.
          </p>

          <h1 className='mt-5'>Privacy Policy </h1>
          <p>Your personal information collected during registration or purchase will be handled in compliance with applicable data protection laws. Anuyog will not share your details with third parties without your consent.
          </p>

          <h1 className='mt-5'>Optional Tools</h1>
          <p>Third-party tools provided through our services are offered "as is." Anuyog assumes no liability for their usage.
          </p>

          <h1 className='mt-5'>Third-Party Links</h1>
          <p>Anuyog is not responsible for third-party websites, content, or services linked through its platform.
          </p>
          <p>Transactions with third parties are at your own risk. Review their policies carefully before engaging.</p>

          <h1 className='mt-5'> USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS</h1>
          <p>By submitting ideas, suggestions, or comments, you grant Anuyog the right to edit, publish, and use them in any medium without obligation or compensation.
Comments must not violate third-party rights, contain harmful content, or mislead others.
</p>

<h1 className='mt-5'>ERRORS, INACCURACIES AND OMISSIONS</h1>
<p>Occasionally, our site or services may contain typographical errors, inaccuracies, or omissions that affect product descriptions, pricing, promotions, offers, shipping charges, transit times, and availability.
</p>
<p>We reserve the right to correct any errors, inaccuracies, or omissions, and to update or change information, including canceling orders, if any information in the service or on related websites is found to be inaccurate, without prior notice (even after you have submitted your order).
</p>
<p>We are not obligated to update, amend, or clarify information in the service or on related websites, including pricing information, except as required by law.
</p>
<p>Any update or refresh date displayed on the service or on related websites should not be interpreted to mean that all information has been modified or updated.
</p>

<h1 className='mt-5'>PROHIBITED USES</h1>
<p>In addition to other restrictions outlined in the Terms of Service, you are not allowed to use the site or its content:</p>

<ul className='fw-bold list-group-numbered'>
  <li>For any illegal activity.
  </li>
  <li>To encourage others to engage in illegal acts.
  </li>
  <li>To violate any local, state, national, or international laws or regulations.
  </li>
  <li>To infringe upon our intellectual property rights or the rights of others.
  </li>
  <li>To engage in any form of harassment, abuse, or discrimination based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability.
  </li>
  <li>To provide false or misleading information.
  </li>
  <li>To upload or transmit harmful viruses or malicious code that could affect the functionality of the Service or any related websites.
  </li>
  <li>To collect or track personal information from others.
  </li>
  <li>To engage in activities like spamming, phishing, scraping, or crawling.
  </li>
  <li>For any immoral or offensive purpose.</li>
  <li>To disrupt or bypass the security measures of the Service, related websites, or the Internet.
  </li>
</ul>
<p>We reserve the right to suspend or terminate your access to the Service or related websites if you violate any of these terms.
</p>

<h1 className='mt-5'>INDEMNIFICATION</h1>
<p>You agree to indemnify, defend, and hold harmless Anuyog, including our parent company, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, service providers, subcontractors, suppliers, interns, and employees.
</p>
<p>You will be held harmless from any claim or demand, including reasonable attorneys' fees, made by any third party.
</p>
<p>This indemnification applies to claims arising from your breach of these Terms of Service or any documents they reference.
</p>
<p>It also applies to your violation of any law or the rights of any third party.
</p>

<h1 className='mt-5'>SEVERABILITY</h1>
<p>If any provision of these Terms of Service is determined to be unlawful, void, or unenforceable, it will still be enforceable to the fullest extent allowed by law.
</p>
<p>The unenforceable portion will be considered severed from these Terms of Service.
</p>
<p>This determination will not affect the validity and enforceability of the remaining provisions.
</p>

<h1 className='mt-5'>TERMINATION
</h1>
<p>The obligations and liabilities incurred by the parties before the termination date will survive the termination for all purposes.
</p>
<p>These Terms of Service are effective until terminated by either you or us.
</p>
<p>You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or by ceasing to use our site.
</p>
<p>If we believe, in our sole judgment, that you have failed to comply with any term or provision of these Terms of Service, we may terminate this agreement without notice.
</p>
<p>If terminated, you will remain liable for all amounts due up to the date of termination and may be denied access to our Services (or parts thereof).

</p>
<h1 className='mt-5'>ENTIRE AGREEMENT
</h1>
<p>A failure to exercise or enforce any right or provision of these Terms of Service does not waive that right or provision.
</p>
<p>These Terms of Service and any related policies posted on our site constitute the entire agreement between you and us.
</p>
<p>These Terms supersede any prior or contemporaneous agreements, communications, and proposals, whether oral or written.</p>
<p>Any ambiguities in interpretation will not be construed against the drafting party.
</p>

<h1 className='mt-5'>Governing Law
</h1>
<p>These terms are governed by and construed in accordance with the laws of India/Madhya Pradesh.
</p>
<p>Any disputes will be subject to the exclusive jurisdiction of the courts in Madhya Pradesh.
</p>

<h1 className='mt-5'> CHANGES TO TERMS OF SERVICE
</h1>
<p>You can review the most current version of the Terms of Service at any time on this page.
</p>
<p>We reserve the right to update, change, or replace any part of these Terms of Service by posting updates on our website.</p>
<p>It is your responsibility to check the website periodically for changes.
</p>
<p>Your continued use of the website or Service after changes are posted constitutes acceptance of those changes.
</p>

<h1 className='mt-5'>Contact Information
</h1>
<p className='text-center'>For queries or concerns, please contact us at:
</p>

<p className='text-center'><strong>Email:
</strong> theanuyoginstitute@gmail.com</p>
<p className='text-center'><strong>Phone:
</strong> +917892307418</p>
<p>By engaging with Anuyog activities, products, or content, you acknowledge that you have read, understood, and agree to these terms and conditions.
</p>
        </div>
      </section>
    </>
  )
}

export default Terms_and_condition
